import type { UseMaskProps } from '@pearlconvert/ui/components/mask/mask.types'

import React, { useEffect, useState } from 'react'

export const useMask = (props: UseMaskProps) => {
  const { initialActive, onDismiss, onStatusChange } = props

  const [isActive, setIsActive] = useState(initialActive)

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ' || event.key === 'Escape') {
      dismissMask()
    }
  }

  const dismissMask = () => {
    setIsActive(false)
    onDismiss?.()
  }

  useEffect(() => {
    setIsActive(initialActive)
  }, [initialActive])

  useEffect(() => {
    onStatusChange?.(isActive)
  }, [isActive, onStatusChange])

  return { isActive, dismissMask, handleKeyDown }
}
